import React from 'react'

import { IconProps } from '../Types'

export const Refresh = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="Refresh"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m21.94,16.54l-.69-2.73s-.03-.06-.04-.08c-.02-.06-.05-.12-.08-.18-.03-.05-.07-.1-.11-.14-.04-.04-.08-.08-.13-.12-.05-.04-.11-.07-.17-.1-.03-.02-.05-.03-.08-.05-.03,0-.06,0-.08,0-.07-.02-.12-.03-.19-.03s-.13,0-.2,0h-.08l-2.77.68c-.52.12-.84.65-.71,1.17.13.52.66.82,1.18.7l.72-.17c-.53.81-1.19,1.52-1.97,2.11-1.32.97-2.91,1.55-4.55,1.64-1.5,0-2.96-.46-4.19-1.31-1.23-.85-2.17-2.06-2.69-3.46-.18-.5-.74-.76-1.25-.57-.51.18-.77.73-.58,1.23.65,1.77,1.84,3.3,3.41,4.37,1.57,1.08,3.43,1.66,5.34,1.66h.05c2.04-.11,4-.82,5.64-2.02.91-.67,1.68-1.47,2.31-2.38l.07.27c.13.52.66.82,1.18.7.52-.12.84-.65.71-1.17l-.03-.02ZM3.09,10.7s.11.07.17.1c.02.02.05.03.07.05.03,0,.06,0,.09.02.07.02.12.02.19.02s.13,0,.2,0h.09l2.77-.68c.52-.12.84-.65.71-1.17-.13-.52-.66-.82-1.18-.7l-.65.16c.53-.75,1.2-1.45,1.97-2.04,1.37-1.05,2.95-1.69,4.46-1.69s2.99.47,4.23,1.33c1.24.87,2.17,2.08,2.68,3.49.18.5.73.77,1.24.58.51-.17.77-.72.59-1.22-.64-1.78-1.82-3.32-3.39-4.42-1.57-1.09-3.43-1.68-5.35-1.68-2.06,0-4.05.86-5.67,2.1-.88.68-1.67,1.5-2.31,2.38l-.08-.34c-.13-.52-.66-.82-1.18-.7-.52.12-.84.65-.71,1.17l.69,2.73s.02.05.04.08c.02.07.05.12.08.18.03.05.07.1.11.14.04.04.08.08.13.12Z"/>',
    }}
  />
)

Refresh.displayName = 'Refresh'

export const tags = ['Refresh', '']
